import styled from 'styled-components';
export const Container = styled.div`
    width: 750px;
    max-height: 45rem;
    .cfCrUs{
        display: flex;
        width: 30rem;
        max-width: 35rem;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-top: .3rem;
        font-size: 1.088rem;
        > div {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            > p:nth-child(3){
                margin-top: .5rem;
            }
        }
    }
    .ctl-HC {
        cursor: pointer;
        > .rt90 {
            transform: rotate(-90deg);
        }
    }
`;
export const Content = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
    padding: 0.5rem;
    gap: 1rem;
    .jcSB{
        justify-content: space-between;
    }
    > div {
        display: flex;
        width: 100%;
        gap: 1rem;
        flex-direction: column;
    }
`;
export const Card = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: 0.75rem;
    gap: 1rem;
    border-radius: 6px;
    background-color: #ffffff;
    box-shadow: 0 calc(2 / 16 * 1rem) calc(8 / 16 * 1rem) rgba(0, 0, 0, .08);
    .nt-gap {
        gap: 0;
    }
    > div {
        display: flex;
        gap: 0.5rem;
    }
    .x-60{
        width: 60%;
    }
    .x-40{
        width: 40%;
    }
    .phone{
        height: 2.5rem;
        margin-right: 0rem;
    }
    .title {
        display: flex;
        justify-content: space-between;
        font-size: 1.1rem;
        font-weight: bold;
        > div {
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
    }
    .qsAtt{
        text-align: center;
        max-width: 6rem;
    }
`;
export const Input = styled.input`
    outline: none;
    border: none;
    width: 100%;
    height: 2.5rem;
    padding: 5px 12px;
    font-size: 14px;
    line-height: 20px;
    font-family: Montserrat, sans-serif;
    border-radius: 6px;
    background-color:${({ theme }) => theme.colors.__white};
    border: solid 1px #ececec; 
    pointer-events: ${({ loading }) => loading ? 'none' : 'auto'};
    color:${({ theme }) => theme.colors.__gray[750]};
    &:disabled {
        opacity: 0.5;
        cursor:no-drop;
        color: #131314;
        background-color:#eff2f7;
    }
`;
export const Textarea = styled.textarea`
    outline: none;
    border: none;
    width: 100%;
    height: 6rem;
    padding: 10px 12px;
    font-size: 14px;
    line-height: 20px;
    border-radius: 6px;
    font-family: Montserrat, sans-serif;
    background-color: ${({ theme }) => theme.colors.__white};
    border: solid 1px #ececec; 
    pointer-events: ${({ loading }) => (loading ? 'none' : 'auto')};
    color: ${({ theme }) => theme.colors.__gray[750]};
    resize: none;

    &:disabled {
        opacity: 0.5;
        cursor: no-drop;
        color: #131314;
        background-color: #eff2f7;
    }
`;
export const Actions = styled.div`
    display: flex;
    width: 100%;
    justify-content: end;
    div:nth-child(1){
        display: flex;
        gap: .5rem;
    };
    span {
        display: flex;
        height: 35px;
        width: 150px;
        justify-content: center;
        align-items: center;
        background: transparent;
        font-weight:500;
        color:#1891fb;
        cursor: pointer;
        border-radius: 4px;
        border: solid 1px;
        &:hover{
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }
    };
    .dsUs {
        color: rgb(251,75,75) ;
    };
    .imCUs{
        width: 170px;
    }
    &.onlyButton {
        justify-content: flex-end;
    }
    button {
        display: flex;
        height: 35px;
        width: 150px;
        justify-content: center;
        align-items: center;
        gap:1rem;
        outline: none;
        border:none; 
        border-radius: 4px;
        font-size: 14px;
        text-align: center;
        font-weight: bolder;
        background-color: #1b72d6;
        color: #ffffff;
        cursor: pointer;
        &:hover{
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }
    }
    .btDi{
        opacity: .6;
        pointer-events: none;
    }
`;
export const LoadingProgress = styled.div`
    position: fixed;
    display: ${({ isOpen }) => isOpen ? 'flex' : 'none'};
    top:0px;
    left: 0px;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    cursor: default;
    animation: ModalShow .1s ease-out;
    user-select: none;
    background-color: #00000040;
    > div {
        width: 400px;
        height: 400px;
        display: flex;
        border-radius: 6px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #ffffff;
        gap: 2rem;
        > div > img{
            max-width: 200px;
        }
        > div:nth-child(2){
            max-width: 200px;
        }
        .loader {
            width: 50px;
            aspect-ratio: 1;
            display: grid;
            border: 4px solid #0000;
            border-radius: 50%;
            border-right-color: #25b09b;
            animation: l15 1s infinite linear;
        }
        .loader::before,
        .loader::after {    
            content: "";
            grid-area: 1/1;
            margin: 2px;
            border: inherit;
            border-radius: 50%;
            animation: l15 2s infinite;
        }
        .loader::after {
            margin: 8px;
            animation-duration: 3s;
        }
        @keyframes l15{ 
            100%{transform: rotate(1turn)}
        }
    }

    @keyframes ModalShow{
        0% {
            opacity: 0;
            transform: scale(1.2);
        }
        100% {
            opacity: 0;
            transform: scale(1);
        }
    };
`;
export const MessageAlert = styled.div`
    max-width: 400px;
    > p {
        text-align: center;
        color: #ce3747;
    };
    span {
        color:#1D86FF;
    };
`;